<template>
  <div class="main" v-loadMore="getList">
    <img class="bg-img" src="./images/bg.jpg" alt="" />
    <div class="input-box">
      <input
        type="text"
        placeholder="搜尋 ID"
        v-model="params.userUuid"
        @keyup.enter="searchList()"
      />
      <img
        class="icon"
        src="./images/search.png"
        alt=""
        srcset=""
        @click="searchList()"
      />
    </div>
    <div class="list-box">
      <div
        class="item"
        v-for="item of list"
        :key="item.userUuid"
        @click="toPlayerDetail(item.userUuid)"
      >
        <img class="img-main" :src="item.imageUrl" alt="" />
        <div class="detail-box">
          <p class="content">{{ item.content }}</p>
          <div class="info-box">
            <div class="left">
              <img class="avatar" :src="item.avatarUrl" alt="" />
              <span class="name">{{ item.nikeName }}</span>
            </div>
            <span class="right">{{ item.votesNum }}票</span>
          </div>
          <button
            class="btn-confirm"
            type="button"
            :class="{ disabled: votesPlayerUuid }"
            @click.stop="voting(item.userUuid)"
          >
            {{
              votesPlayerUuid && votesPlayerUuid === item.userUuid
                ? '已投票'
                : '投票'
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VotingStage',
  data() {
    return {
      params: {
        cp_SUFFIX_NUM: 0,
        pageIndex: null,
        pageSize: 20,
        params: {},
        userUuid: ''
      },
      listLoading: false,
      list: [],
      pageTotal: 0,
      votingLoading: false
    };
  },
  props: {
    votesType: {
      type: String
    },
    uuid: {
      type: String
    },
    votesPlayerUuid: {
      type: String
    },
    endDate: {
      type: [Number, String]
    }
  },
  methods: {
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    voting(playerUuid) {
      if (new Date().getTime() >= this.endDate) {
        this.$confirm({
          content: '投票已截止',
          confirmButtonText: '確定',
          showCancelButton: false,
          closeOnClickModal: false
        });
        return;
      }
      if (this.votesPlayerUuid) {
        return;
      }
      if (this.votingLoading) {
        return;
      }
      this.votingLoading = true;
      this.$http
        .post('/votes/vote', {
          playerUuid: playerUuid,
          userUuid: this.uuid,
          votesType: this.votesType
        })
        .then(() => {
          this.$emit('voteSuccess');
        })
        .catch(() => {
          this.$message('投票失敗');
        })
        .finally(() => {
          this.votingLoading = false;
        });
    },
    searchList() {
      this.params.pageIndex = null;
      this.pageTotal = 0;
      this.list = [];
      this.getList();
    },
    async getList() {
      if (this.listLoading) {
        return;
      }
      try {
        if (
          (this.params.pageIndex === null ||
            this.list.length < this.pageTotal) &&
          !this.listLoading
        ) {
          if (this.params.pageIndex === null) {
            this.params.pageIndex = 0;
          } else {
            this.params.pageIndex += 1;
          }
          this.listLoading = true;
          this.params.votesType = this.votesType;
          const { data } = await this.$http.post('/votes/page', this.params);
          if (!data) {
            this.list = this.list || [];
            return;
          }
          this.list = this.list.concat(data.content) || [];
          this.pageTotal = data.totalRemain;
        }
      } catch (error) {
        if (this.params.pageIndex === 0) {
          this.params.pageIndex = null;
        } else {
          this.params.pageIndex -= 1;
        }
      } finally {
        this.listLoading = false;
      }
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  width: 750px;
  flex: none;
  > .bg-img {
    width: 100%;
    max-width: 100%;
    flex: none;
  }
  .input-box {
    height: 72px;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    input {
      width: 686px;
      height: 72px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 999px;
      flex: none;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 26px;
      padding: 0 28px;
      color: white;
      &::placeholder {
        font-weight: 400;
        font-size: 26px;
        color: rgba(255, 255, 255, 0.55);
      }
    }
    .icon {
      position: absolute;
      right: 48px;
      top: 50%;
      transform: translateY(-50%);
      width: 52px;
      height: 52px;
    }
  }
  .list-box {
    width: 100%;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      width: 334px;
      height: 514px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 32px;
      display: flex;
      flex-direction: column;
      margin-bottom: 18px;
      .img-main {
        width: 100%;
        height: 334px;
        border-radius: 16px;
        background: white;
        object-fit: cover;
      }
      .detail-box {
        padding: 0 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex: auto;
      }
      .content {
        height: 36px;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 26px;
        color: #ffffff;
        width: 100%;
        overflow: hidden;
      }
      .info-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 22px;
        width: 100%;
        overflow: hidden;
        .left {
          display: flex;
          align-items: center;
          .avatar {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            margin-right: 4px;
          }
          .name {
            font-weight: 400;
            font-size: 22px;
            color: rgba(255, 255, 255, 0.77);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 160px;
          }
        }
        .right {
          font-weight: 400;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.77);
          min-width: 80px;
          text-align: right;
        }
      }
      .btn-confirm {
        width: 100%;
        height: 66px;
        background: #ffcb46;
        border-radius: 80px;
        font-size: 26px;
        color: #2e2e2e;
        margin-bottom: 18px;
        &.disabled {
          background: rgba(255, 203, 70, 0.55);
        }
      }
    }
  }
}
</style>
